
import './ContactPage.css'

function ContactPage() { 
    return (
        <div style={{alignContent:'center', justifyContent:'center'}}> 
            <h6 style={{color:'#969696'}}>Contact Us</h6>
            <div style={{
                display:'grid',
                gridTemplateColumns:'360px 360px',
                gridTemplateRows: '30px 30px', 
                justifyContent:'center', 
            }}> 
                <label style={{padding: 10, fontSize:12, color:'#969696', textAlign:'right'}}>For artist information and questions reach out to: </label>
                <a style={{color:'#5c5c5c',fontSize:12, textAlign:'left', padding: 10}} href='mailto:Andrew.Keister@msg.com'>Andrew.Keister@msg.com</a>
                <label style={{padding: 10, fontSize:12, color:'#969696', textAlign:'right'}}>Email any software questions, issues, or ideas to: </label>
                <a style={{color:'#5c5c5c',fontSize:12, textAlign:'left', padding: 10}} href='mailto:audio.dev@thesphere.com'>audio.dev@thesphere.com</a>
            </div>
        </div>
    )
}


export default ContactPage;